import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    closeMyCompanyAccount: 'Close my company account',
    closeThisCompanyAccount: 'Close this company account',
  },
  fr: {
    closeMyCompanyAccount: 'Clôturer le compte de mon entreprise',
    closeThisCompanyAccount: 'Clôturer le compte de cette entreprise',
  },
} as const);

export default locales;
